/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { Platform } from "../types/TPlatform";

/**
 * Detects the current platform by checking for platform-specific
 * global objects and user agent strings.
 *
 * Supports: Samsung Tizen, LG WebOS, Amazon VegaOS (Fire TV), and browsers.
 */
export function detectPlatform(): Platform {
  if (typeof window !== "undefined") {
    const win = window as unknown as Record<string, unknown>;
    const ua =
      typeof navigator !== "undefined" ? navigator.userAgent : "unavailable";

    if (win["tizen"]) {
      return "tizen";
    }

    if (win["webOS"]) {
      return "webos";
    }

    if (
      win["amazonDevice"] ||
      (typeof navigator !== "undefined" &&
        /AFT|AmazonWebAppPlatform/i.test(navigator.userAgent))
    ) {
      return "vegaos";
    }

    // Fallback: when running inside a shell iframe, platform globals
    // (tizen, webOS) are not available in the iframe's scope. Detect
    // the platform from the user-agent string instead.
    if (typeof navigator !== "undefined") {
      if (/Tizen/i.test(ua)) {
        return "tizen";
      }
      if (/Web0S|WebAppManager|webOS/i.test(ua)) {
        return "webos";
      }
    }
  }

  return "browser";
}
